export default __webpack_public_path__ + "static/media/Fonte_TV.883f12b6.jpg";